import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBICbZ95B37BnZXbmzzHbiR0psnRdtsC1E",
  authDomain: "nearbeee-89244.firebaseapp.com",
  projectId: "nearbeee-89244",
  storageBucket: "nearbeee-89244.firebasestorage.app",
  messagingSenderId: "378718628662",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
